import { Environ } from "../types/Environ";
import getEnv from "./getEnv";

const isLocal = (): boolean => {
  return getEnv() === Environ.LOCAL;
};

export default isLocal;
